import { forwardRef } from 'react';
import { DatePickerInput } from './DatePickerInput';
import type { DatePickerInputProps } from './DatePickerInput';
import { DatePickerContainer } from './styles';

export interface DatePickerProps
  extends Pick<
    DatePickerInputProps,
    | 'id'
    | 'name'
    | 'size'
    | 'preventFutureDate'
    | 'preventDatesBefore'
    | 'value'
    | 'onDateChange'
    | 'isDisabled'
    | 'isInvalid'
  > {
  /**
   * Styles overrides.
   */
  className?: string;
}

/**
 * DatePicker component.
 *
 * {@link https://zeroheight.com/76c439891/v/latest/p/39b51a-date-picker Usage guidelines}
 *
 * {@link https://storybook.hotjar.com/?path=/docs/components-datepicker--date-picker Code documentation}
 *
 * @example
 * <DatePicker />
 */
export const DatePicker = forwardRef<HTMLDivElement, DatePickerProps>(
  (
    {
      className,
      isInvalid = false,
      isDisabled = false,
      preventFutureDate = false,
      size = 'm',
      ...props
    }: DatePickerProps,
    ref,
  ) => {
    return (
      <DatePickerContainer ref={ref} className={className}>
        <DatePickerInput
          isInvalid={isInvalid}
          isDisabled={isDisabled}
          preventFutureDate={preventFutureDate}
          size={size}
          {...props}
        />
      </DatePickerContainer>
    );
  },
);

DatePicker.displayName = 'DatePicker';
